import { useState, useEffect } from 'react';
import MobileFilterDropdown from '../mobileFilterDropdown/mobileFilterDropdown';
import styles from './filterAndSort.module.scss';
import SortDropdown from '../sortDropdown/sortDropdown';

const FilterAndSort = ({ filters, products, resources, isOptionActive, useFilterObject }) => {
  const [opened, setOpened] = useState(false);
  const filterKeys = Object.keys(filters);
  const {
    state: { sortOption },
    filterState,
    clearFilters,
    setSortOption,
  } = useFilterObject;

  const clearAll = () => {
    clearFilters();
    setSortOption('');
  };

  useEffect(() => {
    document.body.style.overflow = opened ? 'hidden' : 'auto';
  }, [opened]);

  return (
    <>
      <button
        type="button"
        className={
          filterState.filteredProducts?.length > 0
            ? styles.filterAndSortButtonWithLength
            : styles.filterAndSortButton
        }
        onClick={() => setOpened(true)}
      >
        {resources.filterAndSort.text}
        {filterState.filteredProducts?.length > 0 && (
          <div className={styles.numberOfSelectedFilters}>
            {filterState.filteredProducts?.length}
          </div>
        )}
      </button>
      <div
        className={styles.filterAndSortOverlay}
        style={{ transform: opened ? 'translateX(0%)' : 'translateX(-100%)' }}
      >
        <div className={styles.bottomButtons}>
          <button
            type="button"
            className={styles.clearFilters}
            onClick={() => {
              clearAll();
              setOpened(false);
            }}
          >
            {resources.clearFilters.text}
          </button>
          <button
            type="button"
            className={styles.apply}
            onClick={() => {
              setOpened(false);
            }}
          >
            {`${resources.apply.text} (${filterState.filteredProducts?.length || 0})`}
          </button>
        </div>
        <div className={styles.sortSelectWrapper}>
          <SortDropdown
            resources={resources}
            className={styles.mobileSortSelect}
            sortOption={sortOption}
            setSortOption={setSortOption}
          />
        </div>
        <div className={styles.separator} />

        {filterKeys.map(filter => (
          <MobileFilterDropdown
            key={filter}
            className={styles.mobileFilter}
            products={products}
            filterName={filter}
            options={filters[filter].options}
            resources={resources}
            isOptionActive={isOptionActive}
            useFilterObject={useFilterObject}
          />
        ))}
      </div>
    </>
  );
};

export default FilterAndSort;
